import { useCallback, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { loadEventsFilter } from 'portal/store/events/actions'

export const useFilterLoader = (moduleName, alertType) => {
  const dispatch = useDispatch()
  const { accountId, projectId } = useParams()

  const reload = useCallback(() => {
    if (moduleName) {
      dispatch(loadEventsFilter(accountId, projectId, moduleName, alertType))
    } else {
      // Submission issues does not have a module name and do not require filters to be loaded
      return
    }
  }, [accountId, dispatch, moduleName, projectId, alertType])

  useEffect(() => {
    reload()
  }, [reload])

  // If no moduleName is provided, default to 'delivery'
  const {
    loading,
    error,
    description,
    tradeContractor,
    wasteCarrier,
    subcontractor,
    supplier,
    assigneeIds
  } = useSelector((state: any) => {
    return state.events[`${moduleName ? moduleName : 'delivery'}Filter`]
  })

  return {
    filtersloading: loading,
    filtersError: error,
    description,
    tradeContractor,
    wasteCarrier,
    subcontractor,
    supplier,
    assigneeIds
  }
}
